<template>
  <div class="wrap">
    <applettop class="head" :property="designviews" @changeInit="changeInit"></applettop>
    <div class="containerDesign" :style="curHeight">
      <div class="applet_design" :style="curBoxHeight">
        <div class="applet_tool">
          <el-tabs v-model="activeName">
            <el-tab-pane label="模块组件" name="first">
              <ul class="com_list">
                <li class="com_item" @click="gettool('add', 9)">
                  <i class="iconfont iconqiyejianjie"></i>
                  <span>公司简介</span>
                </li>
                <li class="com_item" @click="gettool('add', 10)">
                  <i class="iconfont iconchanpinjieshao"></i>
                  <span>产品介绍</span>
                </li>
                <li class="com_item" @click="gettool('add', 11)">
                  <i class="iconfont iconqiyezixun"></i>
                  <span>企业资讯</span>
                </li>
                <li class="com_item" @click="gettool('add', 12)">
                  <i class="iconfont iconlianxifangshi"></i>
                  <span>联系方式</span>
                </li>
                <li class="com_item" @click="gettool('add', 13)">
                  <i class="iconfont iconguanlituandui"></i>
                  <span>管理团队</span>
                </li>
                <li class="com_item" @click="gettool('add', 14)">
                  <i class="iconfont iconhezuohuoban"></i>
                  <span>合作伙伴</span>
                </li>
                <li class="com_item" @click="gettool('add', 15)">
                  <i class="iconfont iconqiyezhaopin"></i>
                  <span>企业招聘</span>
                </li>
                <li class="com_item" @click="gettool('add', 16)">
                  <i class="iconfont iconmingpian"></i>
                  <span>名片</span>
                </li>
                <!--<li class="com_item" @click="gettool('add', 17)">-->
                  <!--<i class="iconfont iconvr"></i>-->
                  <!--<span>企业VR介绍</span>-->
                <!--</li>-->
                <li class="com_item" @click="gettool('add', 18)">
                  <i class="iconfont iconmingpian"></i>
                  <span>预约</span>
                </li>
              </ul>
            </el-tab-pane>
            <el-tab-pane label="基本组件" name="second">
              <ul class="com_list">
                <li class="com_item" @click="gettool('add', 1)">
                  <i class="iconfont iconbiaoti"></i>
                  <span>标题</span>
                </li>
                <li class="com_item" @click="gettool('add', 2)">
                  <i class="iconfont iconwenben"></i>
                  <span>文本</span>
                </li>
                <li class="com_item" @click="gettool('add', 3)">
                  <i class="iconfont icontupian"></i>
                  <span>图片</span>
                </li>
                <li class="com_item" @click="gettool('add', 5)">
                  <i class="iconfont iconshipin"></i>
                  <span>视频</span>
                </li>
                <li class="com_item" @click="gettool('add', 4)">
                  <i class="iconfont iconlunbotu"></i>
                  <span>轮播图</span>
                </li>
                <li class="com_item" @click="gettool('add', 6)">
                  <i class="iconfont icontuwen"></i>
                  <span>图文</span>
                </li>
                <li class="com_item" @click="gettool('add', 7)">
                  <i class="iconfont iconplaceholder"></i>
                  <span>占位符</span>
                </li>
              </ul>
              <!--1.标题 2.文本 3.图片  4.轮播图  5.视频 6.图文 7.占位符  8.表单-->
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="applet_preview" :class="{ishide: currentindex==null && showall==0}" @click="hideDesign()">
          <div class="design_preview">
            <div class="control-title">
              <div class="weui-cell nobefore">
                <div class="weui-cell__hd"><img src="/static/img/userDefult.png"></div>
                <div class="weui-cell__bd">个人中心</div>
              </div>
              <p>官网</p>
              <img src="/static/img/menu.png">
            </div>
            <div class="design_outbox">
              <!-- <div class="design_top">官网</div> -->
              <div class="design_edit">
                <!--                    @dragstart="handleDragStart($event, item)"-->
                <!--                    @dragover.prevent="handleDragOver($event, item)"-->
                <!--                    @dragenter="handleDragEnter($event, item)"-->
                <!--                    @dragend="handleDragEnd($event, item)"-->
                <draggable v-model="designviews"
                          :options="{draggable:'.design_item',animation: 150}" :move="getdata" @update="datadragEnd">
                  <transition-group>
                    <div
                      class="design_item" 
                      :class="{'on':currentindex==index}"
                      v-for="(item,index) in designviews"
                      :key="index"
                      @click.stop="choosedesign(item,index)"
                      :draggable="item.draggable"
                    >
                      <div class="design_mask" v-if="index!==currentindex && showall == 1"></div>
                      <div class="design_oper">
                        <ul>
                          <li v-if="index!==0"><i class="el-icon-caret-top" @click.stop="lineNumber(0, index, item)"></i>
                          </li>
                          <li v-if="designviews.length-1!==index"><i class="el-icon-caret-bottom"
                                                                    @click.stop="lineNumber(1, index, item)"></i></li>
                          <li><i class="el-icon-close" @click="designdel(index)"></i></li>
                        </ul>
                      </div>
                      <div class="design_tool">
                        <component v-bind:is="item.template" :property="item.content"></component>
                      </div>
                    </div>
                  </transition-group>
                </draggable>
              </div>
            </div>
          </div>
        </div>
        <div class="applet_params">
          <component
                  v-if="currentview"
                  v-bind:is="currentview.propertytype"
                  :property.sync="currentview.content"
          ></component>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import draggable from 'vuedraggable';
  import applettop from "@/components/applettop.vue";
  import companytool from "@/components/formtools/company.vue";
  import companyProperty from "@/components/formtools/companyProperty.vue";
  import teamtool from "@/components/formtools/team.vue";
  import teamProperty from "@/components/formtools/teamProperty.vue";
  import cooperationtool from "@/components/formtools/cooperation.vue";
  import cooperationProperty from "@/components/formtools/cooperationProperty.vue";
  import myCarttool from "@/components/formtools/myCart.vue";
  import myCartProperty from "@/components/formtools/myCartProperty.vue";
  import vrCompany from "@/components/formtools/vrCompany.vue";
  import vrCompanyProperty from "@/components/formtools/vrCompanyProperty.vue";
  import appointmenttool from "@/components/formtools/appointment.vue";//预约
  import appointmentProperty from "@/components/formtools/appointmentProperty.vue";
  import companyInformationtool from "@/components/formtools/companyInformation.vue";
  import companyInformationProperty from "@/components/formtools/companyInformationProperty.vue";
  import recruitCompanytool from "@/components/formtools/recruitCompany.vue";
  import recruitCompanyProperty from "@/components/formtools/recruitCompanyProperty.vue";
  import contactUstool from "@/components/formtools/contactUs.vue";
  import contactUsProperty from "@/components/formtools/contactUsProperty.vue";
  import producttool from "@/components/formtools/product.vue";
  import productProperty from "@/components/formtools/productProperty.vue";
  import titletool from "@/components/formtools/title.vue"; // 标题
  import texttool from "@/components/formtools/text.vue"; // 标题
  import textProperty from "@/components/formtools/textProperty.vue"; // 标题
  import textimgtool from "@/components/formtools/textimg.vue"; // 标题
  import textimgProperty from "@/components/formtools/textimgProperty.vue"; // 标题
  import imgtool from "@/components/formtools/img.vue"; // 标题
  import imgProperty from "@/components/formtools/imgProperty.vue"; // 标题
  import videotool from "@/components/formtools/video.vue"; // 视频
  import videoProperty from "@/components/formtools/videoProperty.vue"; // 视频
  import titleProperty from "@/components/formtools/titleProperty.vue"; // 标题栏设置
  import captions from "@/components/formtools/captions.vue"; // 文字说明
  import captionsProperty from "@/components/formtools/captionsProperty.vue"; // 文字说明设置
  import datetool from "@/components/formtools/date.vue"; // 日期
  import dateProperty from "@/components/formtools/dateProperty.vue";
  import multiCheck from "@/components/formtools/multiCheck.vue";
  import multiCheckProperty from "@/components/formtools/multiCheckProperty.vue";
  import multiText from "@/components/formtools/multiText.vue";
  import multiTextProperty from "@/components/formtools/multiTextProperty.vue";
  import selecttool from "@/components/formtools/select.vue";
  import selectProperty from "@/components/formtools/selectProperty.vue";
  import selectProvinces from "@/components/formtools/selectProvinces.vue";
  import selectProvincesProperty from "@/components/formtools/selectProvincesProperty.vue";
  import singleCheck from "@/components/formtools/singleCheck.vue";
  import singleCheckProperty from "@/components/formtools/singleCheckProperty.vue";
  import singleText from "@/components/formtools/singleText.vue";
  import singleTextProperty from "@/components/formtools/singleTextProperty.vue";
  import timetool from "@/components/formtools/time.vue";
  import timeProperty from "@/components/formtools/timeProperty.vue";
  import uploadtool from "@/components/formtools/upload.vue";
  import uploadProperty from "@/components/formtools/uploadProperty.vue";
  import rotarySowing from "@/components/formtools/rotarySowing.vue";
  import rotarySowingProperty from "@/components/formtools/rotarySowingProperty.vue";
  import seatline from "@/components/formtools/seatline.vue";

  export default {
    name: "cardDecoration",
    components: {
      draggable,
      companytool,
      companyProperty,
      producttool,
      productProperty,
      companyInformationtool,
      companyInformationProperty,
      contactUstool,
      contactUsProperty,
      applettop,
      titletool,
      texttool,
      textProperty,
      textimgtool,
      textimgProperty,
      imgtool,
      imgProperty,
      videotool,
      videoProperty,
      titleProperty,
      captions,
      captionsProperty,
      datetool,
      dateProperty,
      multiCheck,
      multiCheckProperty,
      multiText,
      multiTextProperty,
      selecttool,
      selectProperty,
      selectProvinces,
      selectProvincesProperty,
      singleCheck,
      singleCheckProperty,
      singleText,
      singleTextProperty,
      timetool,
      timeProperty,
      uploadtool,
      uploadProperty,
      rotarySowing,
      rotarySowingProperty,
      seatline,
      teamtool,
      teamProperty,
      cooperationtool,
      cooperationProperty,
      myCarttool,
      myCartProperty,
      recruitCompanytool,
      recruitCompanyProperty,
      vrCompany,
      vrCompanyProperty,
      appointmenttool,
      appointmentProperty
    },
    data() {
      return {
        flag: true,
        activeName: "first",
        currentindex: "",
        currentview: null,
        designviews: [],
        dragging: null,
        curHeight: null,
        curBoxHeight: null,
        showall: 1 // 0 全部 1 单个
      };
    },
    created() {
      document.body.ondrop = function (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      let h = document.documentElement.clientHeight || document.body.clientHeight;
      // this.curHeight = 'height:'+(h - 85)+'px'; //减去页面上固定高度height
      this.curHeight = 'height:' + (h - 135) + 'px'; //减去页面上固定高度height
      // this.curBoxHeight = 'height:' + (h - 85) + 'px'; //减去页面上固定高度height

      this.InitFn()
    },
    methods: {
      InitFn() {
        this.axios
            .post('companyadmin/v200707/shopconf/get_website', {})
            .then(response => {
				console.log(JSON.parse(response.data.data.website),"JSON.parse(response.data.data.website)")
              if (response.data.code == 0) {
                let list_line = JSON.parse(response.data.data.website)
                if (list_line.length !== 0) {
                  for (let i in list_line) {
                    this.gettool('edit', list_line[i].type, list_line[i].content)
                  }
                  this.currentindex = 0;
                  this.designviews[0].draggable = true // 显示
                  this.currentview = this.designviews[0]
                } else {
                  this.designviews = []
                  this.currentview = null
                }
              } else {
              }
            })
            .catch(response => {
            });
      },
      changeInit() {
        this.InitFn();
      },
      // 获取当前选择的工具项
      //   1.标题
      //   2.文本
      //   3.图片
      //   4.轮播图
      //   5.视频
      //   6.图文
      //   7.占位符
      //   8.表单

      //   9.公司简介
      //   10.产品介绍
      //   11.企业咨询
      //   12.联系方式
      //   13 管理团队
      //   14 合作伙伴
      //   15 企业招聘
      //   16 名片
      //   17 企业VR介绍
      //   18 预约
      gettool(type, typeNumber, option) {
        // type add 添加 edit 编辑 option编辑的内容
        let currentview = null
        switch (typeNumber) {
          case 9: // 公司简介 company
            currentview = this.getcompany(type, option);
            break;
          case 10: // 产品介绍 product
            currentview = this.getproduct(type, option);
            break;
          case 11: // 企业资讯 article
            currentview = this.getarticle(type, option);
            break;
          case 12: // 联系方式 callme
            currentview = this.getcallme(type, option);
            break;
          case 13: // 团队管理 team
            currentview = this.team(type, option);
            break;
          case 14: // 合作伙伴 cooperation
            currentview = this.cooperation(type, option);
            break;
          case 15: // 企业招聘 cooperation
            currentview = this.recruitCompany(type, option);
            break;
          case 16: // 我的名片 myCart
            currentview = this.myCart(type, option);
            break;
          case 17: // 企业VR介绍
            currentview = this.vrCompanyFn(type, option);
            break;
          case 18: // 预约
            currentview = this.appointmentFn(type, option);
            break;
          case 1: // 标题 title
            currentview = this.gettitle(type, option);
            break;
          case 2: // 文本 text
            currentview = this.gettext(type, option);
            break;
          case 3: // 图片 img
            currentview = this.getimg(type, option);
            break;
          case 4: // 轮播图
            currentview = this.rotarylist(type, option);
            break;
          case 5: // 视频 img
            currentview = this.getvideo(type, option);
            break;
          case 6: // 图文
            currentview = this.textimg(type, option);
            break;
          case 7: // 占位符
            currentview = this.seatLine(type, option);
            break;
        }
        // console.log('this.designviews------',this.designviews)
        let ishasflag = false//判断type 为18的是否已经有创建过，type=18只能创建一个
        for (let i in this.designviews) {
          if (this.designviews[i].draggable) {
            this.designviews[i].draggable = false
          }
          if(this.designviews[i].type ===18){
            ishasflag = true
          }
        }
        if (type === 'add') {
          if(ishasflag && typeNumber == 18){
            this.$message.info('该模块已存在，不能再创建！');
            return
          }
          this.showall = 1;
          currentview.draggable = true // 显示
          if (this.currentindex !== null) {
            this.designviews.splice(this.currentindex + 1, 0, currentview);
            this.currentindex = this.currentindex + 1;
            this.currentview = currentview;
          } else {
            this.designviews.push(currentview);
            this.currentindex = this.designviews.length - 1;
            this.currentview = currentview;
          }
        } else {
          this.designviews.push(currentview);
        }
      },
      // 公司简介
      // content：pic：图片地址（数组）name：标题 body：内容
      getcompany(type, option) {
        let content_ = {
          type: 9,
          template: "companytool", // 类型
          propertytype: "companyProperty",
          content: {
            label: "公司简介",
            body: '公司简介详细内容'
          }
        }
        if (type === 'edit') {
          content_.content = option
        }
        return content_;
      },
      // 团队管理
      team(type, option) {
        let content_ = {
          type: 13,
          template: "teamtool", // 类型
          propertytype: "teamProperty",
          content: {
            label: "团队管理",
            list: []
          }
        }
        if (type === 'edit') {
          content_.content = option
        }
        return content_;
      },
      cooperation(type, option) {
        let content_ = {
          type: 14,
          template: "cooperationtool", // 类型
          propertytype: "cooperationProperty",
          content: {
            label: "合作伙伴",
            list: []
          }
        }
        if (type === 'edit') {
          content_.content = option
        }
        return content_;
      },
      // 企业招聘
      recruitCompany(type, option) {
        let content_ = {
          type: 15,
          template: "recruitCompanytool", // 类型
          propertytype: "recruitCompanyProperty",
          content: {
            label: "企业招聘",
            list: []
          }
        }
        if (type === 'edit') {
          content_.content = option
        }
        return content_;

      },

      // 名片
      myCart(type, option) {
        let content_ = {
          type: 16,
          template: "myCarttool", // 类型
          propertytype: "myCartProperty",
          content: {
            label: "我的名片",
            list: []
          }
        }
        if (type === 'edit') {
          content_.content = option
        }
        return content_;
      },
      // 企业Vr介绍
      vrCompanyFn(type, option) {
        let content_ = {
          type: 17,
          template: "vrCompany", // 类型
          propertytype: "vrCompanyProperty",
          content: {
            label: "企业VR介绍",
            title: "",
            url: "",
            pic: "",
            status: 0 // 0 关闭 1开启
          }
        }
        if (type === 'edit') {
          content_.content = option
        }
        return content_;
      },
      // 预约
      appointmentFn(type, option) {
        let content_ = {
          type: 18,
          template: "appointmenttool", // 类型
          propertytype: "appointmentProperty",
          content: {
            label: "预约",
            cover_img:"",
            goods_title:"预约商品",
            goods_list:[],
            employee_title:"预约成员",
            employee_list:[]
          }
        }
        if (type === 'edit') {
          content_.content = option
        }
        return content_;
      },
      // 轮播图
      rotarylist(type, option) {
        let content_ = {
          type: 4,
          template: "rotarySowing", // 类型
          propertytype: "rotarySowingProperty",
          content: {
            pic: []
          }
        }
        if (type === 'edit') {
          content_.content = option
        }
        return content_;
      },
      // 占位符
      seatLine(type, option) {
        let content_ = {
          type: 7,
          template: "seatline", // 类型
          propertytype: "",
          content: {}
        };
        if (type === 'edit') {
          content_.content = option;
        }
        ;
        return content_;
      },
      // 图文
      textimg(type, option) {
        let content_ = {
          type: 6,
          template: "textimgtool", // 类型
          propertytype: "textimgProperty",
          content: {
            label: "图文",
            pic: '',
            text: ''
          }
        };
        if (type === 'edit') {
          content_.content = option;
        }
        ;
        return content_;
      },
      // 产品介绍
      getproduct(type, option) {
        let content_ = {
          type: 10,
          template: "producttool",
          propertytype: "productProperty",
          content: {
            label: "产品介绍",
            pic: []
          }
        }
        if (type === 'edit') {
          content_.content = option
        }
        return content_;
      },
      // 企业资讯 content：list：列表
      // name：标题 create_time：时间 pic：图片地址 body：内容
      getarticle(type, option) {
        let content_ = {
          type: 11,
          template: "companyInformationtool",
          propertytype: "companyInformationProperty",
          content: {
            name: "企业资讯",
            list: []
          }
        }
        if (type === 'edit') {
          content_.content = option
        }
        return content_;
      },
      // 联系方式 lat：纬度 lng：经度 address：地址 mobile：电话
      getcallme(type, option) {
        let content_ = {
          type: 12,
          template: "contactUstool",
          propertytype: "contactUsProperty",
          content: {
            label: '联系方式',
            lat: '',
            lng: '',
            address: '',
            mobile: '',
            name: ''
          }
        }
        if (type === 'edit') {
          content_.content = option
        }
        return content_;
      },
      // 基本组件 标题
      gettitle(type, option) {
        let content_ = {
          type: 1,
          template: "titletool",
          propertytype: "titleProperty",
          content: {
            label: "标题栏"
          }
        }
        if (type === 'edit') {
          content_.content = option
        }
        return content_;
      },
      // 基本组件 文本 name：主标题，title：副标题 body：内容
      gettext(type, option) {
        let content_ = {
          type: 2,
          template: "texttool",
          propertytype: "textProperty",
          content: {
            body: '内容'
          }
        }
        if (type === 'edit') {
          content_.content = option
        }
        return content_;
      },
      // 基本组件 图片
      getimg(type, option) {
        let content_ = {
          type: 3,
          template: "imgtool",
          propertytype: "imgProperty",
          content: {
            pic: ''
          }
        }
        if (type === 'edit') {
          content_.content = option
        }
        return content_;
      },
      // 基本组件 视频
      getvideo(type, option) {
        let content_ = {
          type: 5,
          template: "videotool",
          propertytype: "videoProperty",
          content: {
            video: '',
            poster: ''
          }
        }
        if (type === 'edit') {
          content_.content = option
        }
        return content_;
      },
      // 点击当前项
      choosedesign(item, index) {
        this.showall = 1
        this.currentview = item;
        this.currentindex = index;
      },
      // 移动当前选项
      lineNumber(option, index, item) {
        // option 0 上 1 下
        if (this.flag) {
          this.flag = false
          // designviews
          const newItems = [...this.designviews]
          let index_Line = index + 1
          if (Number(option) === 0) {
            index_Line = index - 1
          }
          newItems.splice(index_Line, 0, ...newItems.splice(index, 1))
          for (let i in newItems) {
            newItems[i].draggable =
                Number(i) === index_Line
                    ? true
                    : false;
          }
          this.currentindex = index_Line
          this.designviews = newItems
          setTimeout(() => {
            this.flag = true
          }, 300)
        }
      },
      // 删除
      designdel(index) {
        // this.designviews[index-1]
        let self_ = this

        this.$confirm('确认要删除模版模块?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          showClose: false,
          closeOnClickModal: false
        }).then(() => {
          self_.currentview = this.designviews[index - 1]
          self_.currentindex = index - 1
          self_.designviews.splice(index, 1);
        }).catch(() => {
        });
      },
      getdata(data) {
      },
      datadragEnd(evt) {

        this.currentindex = evt.newIndex
      },
      onSubmit() {
      },
      // 传递数据
      getMsgFormSon(data) {
      },
      hideDesign() {
        this.showall = 0
        this.currentindex = null
      }
    }
  };
</script>

<style scoped>
.control-title{font-weight: 500; line-height: 62px;} 
.control-title::before{display: none;}
.control-title .weui-cell{position: absolute; left: 15px; top: 50%; margin-top: -13px; height: 32px; padding: 3px; border: 1px solid #ebebeb; border-radius: 15px;}
.control-title .weui-cell__hd{width: 26px; height: 26px; border-radius: 50%; overflow: hidden;}
.control-title .weui-cell__hd img{position: static; margin: 0; display: block; width: 100%; height: 100%; object-fit: cover;}
.control-title .weui-cell__bd{padding: 0 8px; font-size: 12px;}
</style>